import { useState } from "react";

import type { LeadTableFilterSubPropsV2 } from "./types";

import { SkeletonLoader } from "../../SkeletonLoader";
import { useLeadsContextV2 } from "../providers/LeadsProviderV2";
import { MobileFiltersBottomSheetV2 } from "./MobileFiltersBottomSheetV2";

export const MobileFiltersV2 = ({
  handleDateRangePicker,
  handleSearchInput,
  handleCountryDropdown,
  canViewPII,
  initialCountryCodes,
  translations,
}: LeadTableFilterSubPropsV2) => {
  const {
    state: {
      searchQuery,
      selected: { countryCodes: selectedCountryCodes },
    },
  } = useLeadsContextV2();

  const { countryCodeMapping } = translations;

  const [selectedDateOption, setSelectedDateOption] = useState("last30days");

  const countryCodeOptions = (initialCountryCodes ?? []).map((code) => ({
    value: code,
    label: countryCodeMapping.get(code) ?? code,
  }));

  const handleApply = (params: {
    dateOption: string;
    dateRange: { from: Date; to: Date };
    countryCodes: string[];
  }) => {
    setSelectedDateOption(params.dateOption);
    handleDateRangePicker({
      startDate: params.dateRange.from,
      endDate: params.dateRange.to,
    });
    handleCountryDropdown?.(
      params.countryCodes.map((code) => ({
        value: code,
        label: countryCodeMapping.get(code) ?? code,
      })),
    );
  };

  const handleReset = () => {
    const today = new Date();
    const start = new Date(today);
    start.setDate(start.getDate() - 30);
    handleDateRangePicker({ startDate: start, endDate: today });
    handleCountryDropdown?.(countryCodeOptions);
    setSelectedDateOption("last30days");
  };

  const isFiltersLoading = initialCountryCodes === undefined;

  if (isFiltersLoading) {
    return (
      <div className="mt-4 flex flex-col gap-4">
        <div className="flex h-10 items-center gap-2">
          <SkeletonLoader variant="rectangular" height={10} />
          <SkeletonLoader variant="rectangular" height={10} width={10} />
        </div>
      </div>
    );
  }

  return (
    <div className="mt-4 flex flex-col gap-4">
      <MobileFiltersBottomSheetV2
        handleSearchInput={handleSearchInput}
        canViewPII={canViewPII}
        searchQuery={searchQuery}
        countryOptions={countryCodeOptions}
        selectedCountryCodes={
          (selectedCountryCodes as string[])?.length > 0
            ? (selectedCountryCodes as string[])
            : countryCodeOptions.map((o) => o.value)
        }
        selectedDateOption={selectedDateOption}
        onApply={handleApply}
        onReset={handleReset}
      />
    </div>
  );
};
